import CargoOfficerAddRequest from "../../api/raily/cargo-officer/add/cargo-officer-add.request";
import cargoOfficerApiService from "../../api/raily/cargo-officer/cargo-officer-api.service";
import dataLoadErrorFactory from "../../utils/data-load-error/data-load-error.factory";
import handleErrorFactory from "../../utils/handle-error/handle-error.factory";
import HttpError from "../../utils/http/http.error";
import CargoOfficerAddError from "./add/cargo-officer-add-error";
import CargoOfficerAddParams from "./add/cargo-officer-add-params";
import cargoOfficerAddParamsFactory from "./add/cargo-officer-add-params.factory";

const add = async (
  params: CargoOfficerAddParams,
  abortSignal: AbortSignal,
): Promise<void> => {
  const request: CargoOfficerAddRequest =
    cargoOfficerAddParamsFactory.create(params);

  try {
    const response = await cargoOfficerApiService().add(request, abortSignal);

    if (response.status !== 201) {
      throw dataLoadErrorFactory.createUnexpectedError();
    }
  } catch (_error) {
    const error = _error as HttpError | CargoOfficerAddError;

    throw handleErrorFactory.handleCustomError(error);
  }
};

const cargoOfficerService = {
  add,
};

export default cargoOfficerService;
